import { render, staticRenderFns } from "./ShareDocument.vue?vue&type=template&id=79f46acb&scoped=true"
import script from "./ShareDocument.vue?vue&type=script&lang=js"
export * from "./ShareDocument.vue?vue&type=script&lang=js"
import style0 from "./ShareDocument.vue?vue&type=style&index=0&id=79f46acb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f46acb",
  null
  
)

export default component.exports